/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_SUBSCRIPTION_PACKAGES_BEGIN,
  LIST_SUBSCRIPTION_PACKAGES_SUCCESS,
  LIST_SUBSCRIPTION_PACKAGES_ERR,

  CREATE_SUBSCRIPTION_PACKAGE_BEGIN,
  CREATE_SUBSCRIPTION_PACKAGE_SUCCESS,
  CREATE_SUBSCRIPTION_PACKAGE_ERR,

  UPDATE_SUBSCRIPTION_PACKAGE_BEGIN,
  UPDATE_SUBSCRIPTION_PACKAGE_SUCCESS,
  UPDATE_SUBSCRIPTION_PACKAGE_ERR,

  DELETE_SUBSCRIPTION_PACKAGE_BEGIN,
  DELETE_SUBSCRIPTION_PACKAGE_SUCCESS,
  DELETE_SUBSCRIPTION_PACKAGE_ERR,

  BLOCK_SUBSCRIPTION_PACKAGE_BEGIN,
  BLOCK_SUBSCRIPTION_PACKAGE_SUCCESS,
  BLOCK_SUBSCRIPTION_PACKAGE_ERR,

  UNBLOCK_SUBSCRIPTION_PACKAGE_BEGIN,
  UNBLOCK_SUBSCRIPTION_PACKAGE_SUCCESS,
  UNBLOCK_SUBSCRIPTION_PACKAGE_ERR,

  GET_SUBSCRIPTION_PACKAGE_DETAILS_BEGIN,
  GET_SUBSCRIPTION_PACKAGE_DETAILS_SUCCESS,
  GET_SUBSCRIPTION_PACKAGE_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateSubscriptionPackage: false,
  errorCreateSubscriptionPackage: "",
  loadingUpdateSubscriptionPackage: false,
  errorUpdateSubscriptionPackage: "",
  subscriptionPackages: [],
  totalSubscriptionPackages: 0,
  totalSubscriptionPackagesPages: 0,
  loadingDeleteSubscriptionPackage: false,
  errorDeleteSubscriptionPackage: "",
  loadingBlockSubscriptionPackage: false,
  errorBlockSubscriptionPackage: null,
  loadingUnblockSubscriptionPackage: false,
  errorUnblockSubscriptionPackage: null,
  loadingGetSubscriptionPackageDetails: false,
  errorGetSubscriptionPackageDetails: null,
  subscriptionPackageDetails: {},
};

const subscriptionPackagesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_SUBSCRIPTION_PACKAGE_BEGIN:
      return {
        ...state,
        loadingCreateSubscriptionPackage: true,
        errorCreateSubscriptionPackage: "",
      };
    case CREATE_SUBSCRIPTION_PACKAGE_SUCCESS:
      return {
        ...state,
        subscriptionPackages: [...state.subscriptionPackages, data],
        loadingCreateSubscriptionPackage: false,
        errorCreateSubscriptionPackage: "",
      };
    case CREATE_SUBSCRIPTION_PACKAGE_ERR:
      return {
        ...state,
        errorCreateSubscriptionPackage: err,
        loadingCreateSubscriptionPackage: false,
      };

    case LIST_SUBSCRIPTION_PACKAGES_BEGIN:
      return {
        ...state,
        loadingListSubscriptionPackages: true,
        errorListSubscriptionPackages: false,
        totalSubscriptionPackages: 0,
        totalSubscriptionPackagesPages: 0,
      };
    case LIST_SUBSCRIPTION_PACKAGES_SUCCESS:
      return {
        ...state,
        subscriptionPackages: [...data.results],
        loadingListSubscriptionPackages: false,
        errorListSubscriptionPackages: null,
        totalSubscriptionPackages: data.total_count,
        totalSubscriptionPackagesPages: data.total_pages,
      };
    case LIST_SUBSCRIPTION_PACKAGES_ERR:
      return {
        ...state,
        errorListSubscriptionPackages: err,
        loadingListSubscriptionPackages: false,
        totalSubscriptionPackages: 0,
        totalSubscriptionPackagesPages: 0,
      };

    case UPDATE_SUBSCRIPTION_PACKAGE_BEGIN:
      return {
        ...state,
        loadingUpdateSubscriptionPackage: true,
        errorUpdateSubscriptionPackage: false,
      };
    case UPDATE_SUBSCRIPTION_PACKAGE_SUCCESS:
      const updatedSubscriptionPackages = state.subscriptionPackages.map(
        (subscriptionPackage) =>
          subscriptionPackage.id === data.id
            ? { ...subscriptionPackage, ...data }
            : subscriptionPackage
      );
      return {
        ...state,
        subscriptionPackages: updatedSubscriptionPackages,
        loadingUpdateSubscriptionPackage: false,
        errorUpdateSubscriptionPackage: null,
      };
    case UPDATE_SUBSCRIPTION_PACKAGE_ERR:
      return {
        ...state,
        errorUpdateSubscriptionPackage: err,
        loadingUpdateSubscriptionPackage: false,
      };

    case DELETE_SUBSCRIPTION_PACKAGE_BEGIN:
      return {
        ...state,
        loadingDeleteSubscriptionPackage: true,
        errorDeleteSubscriptionPackage: null,
      };
    case DELETE_SUBSCRIPTION_PACKAGE_SUCCESS:
      return {
        ...state,
        subscriptionPackages: state.subscriptionPackages.filter(
          (subscriptionPackage) => subscriptionPackage.id !== data.id
        ),
        loadingDeleteSubscriptionPackage: false,
        errorDeleteSubscriptionPackage: null,
      };
    case DELETE_SUBSCRIPTION_PACKAGE_ERR:
      return {
        ...state,
        errorDeleteSubscriptionPackage: err,
        loadingDeleteSubscriptionPackage: false,
      };

    case BLOCK_SUBSCRIPTION_PACKAGE_BEGIN:
      return {
        ...state,
        loadingBlockSubscriptionPackage: true,
        errorBlockSubscriptionPackage: null,
      };
    case BLOCK_SUBSCRIPTION_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingBlockSubscriptionPackage: false,
        errorBlockSubscriptionPackage: null,
      };
    case BLOCK_SUBSCRIPTION_PACKAGE_ERR:
      return {
        ...state,
        errorBlockSubscriptionPackage: err,
        loadingBlockSubscriptionPackage: false,
      };

    case UNBLOCK_SUBSCRIPTION_PACKAGE_BEGIN:
      return {
        ...state,
        loadingUnblockSubscriptionPackage: true,
        errorUnblockSubscriptionPackage: null,
      };
    case UNBLOCK_SUBSCRIPTION_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingUnblockSubscriptionPackage: false,
        errorUnblockSubscriptionPackage: null,
      };
    case UNBLOCK_SUBSCRIPTION_PACKAGE_ERR:
      return {
        ...state,
        loadingUnblockSubscriptionPackage: false,
        errorUnblockSubscriptionPackage: err,
      };

    case GET_SUBSCRIPTION_PACKAGE_DETAILS_BEGIN:
      return {
        ...state,
        subscriptionPackageDetails: {},
        loadingGetSubscriptionPackageDetails: true,
        errorGetSubscriptionPackageDetails: null,
      };
    case GET_SUBSCRIPTION_PACKAGE_DETAILS_SUCCESS:
      return {
        ...state,
        subscriptionPackageDetails: data,
        loadingGetSubscriptionPackageDetails: false,
        errorGetSubscriptionPackageDetails: null,
      };
    case GET_SUBSCRIPTION_PACKAGE_DETAILS_ERR:
      return {
        ...state,
        subscriptionPackageDetails: {},
        loadingGetSubscriptionPackageDetails: false,
        errorGetSubscriptionPackageDetails: err,
      };

    default:
      return state;
  }
};

export { subscriptionPackagesReducer };
